import React, { useEffect, useState } from 'react';
import { Autocomplete, Box, Button, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';
import reqProvider from '../../util/requests/reqProvider';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../globalStore/store';
import { nextStep, previousStep } from '../../reducers/companyRegistrationStep/stepperSlice';

const BusinessUnitRegistration = () => {
  const [formData, setFormData] = React.useState({
    companyId: useSelector((state: RootState) => state.selectedCompany.selectedCompany),
    name: '',
    fullAddress: '',
    simplifiedFlag: true
  });
  const [places, setPlaces] = React.useState<string[]>([]);
  const [filteredPlaces, setFilteredPlaces] = useState<string[]>([]);
  const [buName, setBuName] = React.useState('');
  const dispatch = useDispatch();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const fetchData = async (search: string) => {
    try {
      const result = await reqProvider.get('google/search', search === 'address' ? { input: formData.fullAddress } : { input: buName });
      const formattedPlaces = result.data.map((place: any) =>
        `${place.postalCode ? place.postalCode + ' ' : ''}${place.city ? place.city + ', ' : ''}${place.street ? place.street + ' ' : ''}${place.streetNumber ? place.streetNumber : ''}`
      );
      setPlaces(formattedPlaces);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleRegistration = async () => {
    try {
      const response = await reqProvider.post('businessUnit', formData);
      if (response.status === 200) {
        dispatch(nextStep());
      }
    } catch (error) {
      console.error('Error registering business unit:', error);
    }
  };

  useEffect(() => {
    if (buName.length > 2) {
      fetchData('name');
    }
  }, [buName]);

  useEffect(() => {
    if (formData.fullAddress.length > 2) {
      fetchData('address');
    }
  }, [formData.fullAddress]);

  useEffect(() => {
    const normalize = (str: string) => str.replace(/[\s,]+/g, '').toLowerCase();
    setFilteredPlaces(
      places.filter(place =>
        normalize(place).includes(normalize(formData.fullAddress))
      )
    );
  }, [places]);

  return (
    <Box display="flex" flexDirection="column" gap={3} width={isSmallScreen ? '100%' : 350 } marginTop={5}>
      <Typography variant="h6">Mi a neve a vendéglátóhelynek?</Typography>
      <TextField
        fullWidth
        label="Hely neve"
        variant="outlined"
        value={formData.name}
        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        onBlur={(e) => setBuName(e.target.value)}
      />

      <Typography variant="h6">Hol található a vendéglátóhely?</Typography>
      <Autocomplete
        fullWidth
        options={filteredPlaces}
        filterOptions={(options) => options}
        getOptionLabel={(option) => option}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Pontos cím"
            variant="outlined"
            onChange={(e) => setFormData({ ...formData, fullAddress: e.target.value })}
          />
        )}
        value={formData.fullAddress}
        onInputChange={(event, value) => setFormData({ ...formData, fullAddress: value })}
      />

      <Box display="flex" flexDirection={"column"} alignItems="center" gap={2}>
        <Button variant="contained" disabled={formData.name.length < 1 || formData.fullAddress.length < 1} onClick={handleRegistration}>
          Regisztrálom az üzleti egységet
        </Button>
        <Button variant="outlined" sx={{ width: '25%', borderRadius: '30px' }} onClick={() => { dispatch(previousStep()) }}>
          Vissza
        </Button>
      </Box>
    </Box>
  );
};

export default BusinessUnitRegistration;